<zp-toolbar-popover title="Account Manager">

  <div class="flex justify-between items-center">
    <div class="flex items-center gap-2">
      <img
        class="size-[34px] rounded-full"
        src="{{accountManagerData.fullImageUrl}}"
        (error)="onAmImgError($event)"
        alt="Account Manager Avatar"
      />
      <span class="text-base">{{accountManagerData.name}}</span>
    </div>
    <div class="flex items-center">
      @if (accountManagerData.email) {
        <a
          [href]="'mailto:' + accountManagerData.email"
          pButton
          target="_blank"
          text
          rounded
          severity="secondary"
          size="small"
          title="Contact Account Manager"
        >
          <cw-icon svgId="envelope" class="size-[18px] contact-envelope primary-color" />
        </a>
      }
    </div>
  </div>

</zp-toolbar-popover>
